import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
export var SpotlightItemType;
(function (SpotlightItemType) {
    SpotlightItemType["NAVIGATION"] = "navigation";
    SpotlightItemType["ACTION"] = "action";
    SpotlightItemType["EUREKA_OBJECT"] = "eureka_object";
    SpotlightItemType["EUREKA_QUERY"] = "eureka_query";
})(SpotlightItemType || (SpotlightItemType = {}));
export const NAVIGATION_ITEMS = [
    {
        id: 'nav-home',
        label: 'Home',
        description: 'Go to home page',
        icon: IconID.THOUGHTSPOT,
        type: SpotlightItemType.NAVIGATION,
        path: '/home',
        keywords: ['dashboard', 'start', 'main'],
    },
    {
        id: 'nav-data',
        label: 'Data',
        description: 'Manage data sources and connections',
        icon: IconID.TABLE,
        type: SpotlightItemType.NAVIGATION,
        path: '/data',
        keywords: ['sources', 'tables', 'database', 'connections'],
    },
    {
        id: 'nav-liveboards',
        label: 'Liveboards',
        description: 'View and manage liveboards',
        icon: IconID.LIVEBOARD_V2,
        type: SpotlightItemType.NAVIGATION,
        path: '/pinboards',
        keywords: ['dashboards', 'reports', 'visualizations'],
    },
    {
        id: 'nav-answers',
        label: 'Answers',
        description: 'View saved answers',
        icon: IconID.ANSWER,
        type: SpotlightItemType.NAVIGATION,
        path: '/answers',
        keywords: ['queries', 'search', 'saved'],
    },
    {
        id: 'nav-spotiq',
        label: 'SpotIQ',
        description: 'AI-powered insights',
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/spotiq',
        keywords: ['ai', 'insights', 'analytics', 'machine learning'],
    },
    {
        id: 'nav-admin',
        label: 'Admin',
        description: 'Administration settings',
        icon: IconID.AXIS_SETTINGS,
        type: SpotlightItemType.NAVIGATION,
        path: '/admin',
        keywords: ['settings', 'configuration', 'management'],
    },
    {
        id: 'nav-settings',
        label: 'Settings',
        description: 'User and system settings',
        icon: IconID.TOOLTIP_SETTINGS,
        type: SpotlightItemType.NAVIGATION,
        path: '/admin/settings',
        keywords: ['preferences', 'configuration', 'options'],
    },
];
export const ACTION_ITEMS = [
    {
        id: 'action-create-liveboard',
        label: 'Create Liveboard',
        description: 'Create a new liveboard',
        icon: IconID.ADD_NOTE_OUTLINE,
        type: SpotlightItemType.ACTION,
        keywords: ['new', 'dashboard', 'add'],
    },
    {
        id: 'action-create-answer',
        label: 'Create Answer',
        description: 'Start a new search query',
        icon: IconID.ADD_NOTE_OUTLINE,
        type: SpotlightItemType.ACTION,
        keywords: ['new', 'search', 'query', 'add'],
    },
    {
        id: 'action-create-worksheet',
        label: 'Create Worksheet',
        description: 'Create a new worksheet',
        icon: IconID.ADD_NOTE_OUTLINE,
        type: SpotlightItemType.ACTION,
        keywords: ['new', 'data model', 'add'],
    },
    {
        id: 'action-create-user',
        label: 'Create User',
        description: 'Add a new user',
        icon: IconID.ADD_NOTE_OUTLINE,
        type: SpotlightItemType.ACTION,
        keywords: ['new', 'add', 'member'],
    },
    {
        id: 'action-create-group',
        label: 'Create Group',
        description: 'Create a new user group',
        icon: IconID.GROUP,
        type: SpotlightItemType.ACTION,
        keywords: ['new', 'add', 'team'],
    },
];
export const SPOTLIGHT_CATEGORIES = [
    {
        id: 'navigation',
        title: 'Navigation',
        items: NAVIGATION_ITEMS,
    },
    {
        id: 'actions',
        title: 'Quick Actions',
        items: ACTION_ITEMS,
    },
];
export const getAllSpotlightItems = () => {
    return [...NAVIGATION_ITEMS, ...ACTION_ITEMS];
};
export const filterSpotlightItems = (items, query) => {
    if (!query.trim()) {
        return items;
    }
    const lowerQuery = query.toLowerCase().trim();
    return items.filter(item => {
        const labelMatch = item.label.toLowerCase().includes(lowerQuery);
        const descriptionMatch = item.description
            ?.toLowerCase()
            .includes(lowerQuery);
        const keywordsMatch = item.keywords?.some(keyword => keyword.toLowerCase().includes(lowerQuery));
        return labelMatch || descriptionMatch || keywordsMatch;
    });
};
//# sourceMappingURL=spotlight.types.js.map